import { render, staticRenderFns } from "./examineSpectaculars.vue?vue&type=template&id=4d65a320&scoped=true&"
import script from "./examineSpectaculars.vue?vue&type=script&lang=js&"
export * from "./examineSpectaculars.vue?vue&type=script&lang=js&"
import style0 from "./examineSpectaculars.vue?vue&type=style&index=0&id=4d65a320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d65a320",
  null
  
)

export default component.exports